import { Row, Col, Input, Button } from 'reactstrap';

import { useFormik } from 'formik';

import { useTranslation } from 'react-i18next';
import { CategorySearchFilters } from 'types/category/categoryTypes';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useDispatch } from 'react-redux';
import { setPageFilters } from 'slices/category/reducer';

interface CategorySearchFormProps {
  _isDarkMode?: boolean;
  onSubmit: (value: CategorySearchFilters) => void;
}

const CategorySearchForm = ({
  _isDarkMode = false,
  onSubmit,
}: CategorySearchFormProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const CategoryState = useSelector((state: RootState) => state.Category);
  const { PageFilters } = CategoryState;
  const formik = useFormik({
    initialValues: PageFilters,
    enableReinitialize: true,
    onSubmit: (values) => {
      onSubmit(values);
      dispatch(setPageFilters(values));
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} data-testid="promotionSearchForm">
      <Row>
        <Col md={8} lg={3} className="col-xxl-3 px-2 mx-1">
          <div className={`search-box me-2 mb-2 `}>
            <Input
              type="text"
              name="categoryName"
              placeholder={t('SearchProductCategory')}
              value={formik.values.categoryName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{ height: 38 }}
              data-testid="search-form-categoryName"
            />
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </Col>

        <Col md={2} lg={2} className="col-xxl-1">
          <Button
            color="success"
            type="submit"
            outline
            data-testid="search-form-btn-submit"
          >
            {t('Search')}
          </Button>
        </Col>

        {/* <Col sm={4} className="col-xxl-1"></Col> */}
      </Row>
    </form>
  );
};
export default CategorySearchForm;
